import sign from './sign'

const plat = {
  path: 'plat',
  component: resolve => require(['../../pages/plat'], resolve),
  redirect: 'plat/sign',
  children: [
    sign
  ]
}

export default plat
